export default __webpack_public_path__ + "empty.160fbaa1.jpg";